module.exports = __webpack_public_path__ + "static/media/HCMM222.2b89436b.jpg";